import React from 'react'
import '../Style/Loading.css'
import BeatLoader from "react-spinners/BeatLoader";

function Loading_Screen() {
  return (
    <>
        <div className='Loading-Screen'>
            <BeatLoader />
        </div>
    </>
  )
}

export default Loading_Screen